const vehicle_create = require("./proworkicon_machine_create001.png");
const vehicle_update = require("./proworkicon_machine_edit001.png");
const vehicle_delete = require("./proworkicon_machine_delete001.png");
const job_create = require("./proworkicon_jobpack_create001.png");
const job_update = require("./proworkicon_jobpack_edit001.png");
const job_delete = require("./proworkicon_jobpack_delete001.png");
const report_create = require("./proworkicon_reports_create001.png");
const report_update = require("./proworkicon_reports_edit001.png");
const report_delete = require("./proworkicon_reports_delete001.png");
const equipment_create = require("./proworkicon_equipement_create001.png");
const equipment_update = require("./proworkicon_equipement_edit001.png");
const equipment_delete = require("./proworkicon_equipement_delete001.png");
const toolbox_create = require("./proworkicon_equipement_create001.png");
const toolbox_update = require("./proworkicon_equipement_edit001.png");
export default {
    vehicle: {
        create: vehicle_create,
        update: vehicle_update,
        delete: vehicle_delete,
    },
    jobpack: { create: job_create, update: job_update, delete: job_delete },
    report: {
        create: report_create,
        update: report_update,
        delete: report_delete,
    },
    equipment: { create: equipment_create, update: equipment_update, delete: equipment_delete },
    reports: { create: toolbox_create, update:toolbox_update, delete: report_delete }
};
